/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AnalyseImportUsersQueryVariables = Types.Exact<{
  file: Types.Scalars['Upload'];
}>;


export type AnalyseImportUsersQuery = { procedure_import_users_analyse: { id: number, step?: string | undefined, isDone: boolean, isErrored: boolean, isTerminated: boolean, isNotStartedYet: boolean, isInProgress: boolean, errors?: Array<{ step?: string | undefined, message: string }> | undefined } };


export const AnalyseImportUsersDocument = gql`
    query AnalyseImportUsers($file: Upload!) {
  procedure_import_users_analyse(file: $file) {
    id
    step
    isDone
    isErrored
    isTerminated
    isNotStartedYet
    isInProgress
    errors {
      step
      message
    }
  }
}
    `;

/**
 * __useAnalyseImportUsersQuery__
 *
 * To run a query within a React component, call `useAnalyseImportUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyseImportUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyseImportUsersQuery({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAnalyseImportUsersQuery(baseOptions: Apollo.QueryHookOptions<AnalyseImportUsersQuery, AnalyseImportUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyseImportUsersQuery, AnalyseImportUsersQueryVariables>(AnalyseImportUsersDocument, options);
      }
export function useAnalyseImportUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyseImportUsersQuery, AnalyseImportUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyseImportUsersQuery, AnalyseImportUsersQueryVariables>(AnalyseImportUsersDocument, options);
        }
export type AnalyseImportUsersQueryHookResult = ReturnType<typeof useAnalyseImportUsersQuery>;
export type AnalyseImportUsersLazyQueryHookResult = ReturnType<typeof useAnalyseImportUsersLazyQuery>;
export type AnalyseImportUsersQueryResult = Apollo.QueryResult<AnalyseImportUsersQuery, AnalyseImportUsersQueryVariables>;